import { VideoIcon } from '@hedepy/icons/refactor/Video'

import { RadioGroup, RadioGroupItem } from '@/legacy-src/components/ui/radio-group'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Label } from '@/src/domains/design-system/components/Label'
import { TherapistFilterMenuLabelUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuLabel'
import { SessionTypeFilter } from '@/src/domains/therapist-filters/constants'
import { getTherapistSessionTypeFilterName } from '@/src/domains/therapist-filters/utils/getTherapistSessionTypeFilterName'

const options = [SessionTypeFilter.ALL, SessionTypeFilter.ONLINE, SessionTypeFilter.OFFLINE, SessionTypeFilter.HYBRID]

export interface TherapistSessionTypeFilterUIProps {
  value: string | undefined
  onChange: (value: string) => void
}

export const TherapistSessionTypeFilterUI = ({ value, onChange }: TherapistSessionTypeFilterUIProps) => {
  const { t } = getTranslate()

  return (
    <div className="m-5 flex flex-col gap-6">
      <TherapistFilterMenuLabelUI Icon={VideoIcon}>
        {t('component.therapist.filter.event-type.title')}
      </TherapistFilterMenuLabelUI>
      <RadioGroup value={value ?? SessionTypeFilter.ALL} onValueChange={onChange} className="grid grid-cols-2 gap-5">
        {options.map((type) => (
          <div key={type} className="inline-flex items-center gap-3">
            <RadioGroupItem value={type} id={type} />
            <Label size="m" variant="selection-control" className="grow" htmlFor={type}>
              {getTherapistSessionTypeFilterName(type, t)}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  )
}
